angular.module('rjmNg.directives').directive "signupChannelsGoogleAds", [
  () ->
    restrict: "E"
    templateUrl: "directive.signupChannelsGoogleAds.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$location"
      "$routeParams"
      "$timeout"
      "$url"
      "$window"
      "app"
      "appRoute"
      "InputConnections"
      "Integrations"
      "jobService"
      "jobTypes"
      "notification"
      (
        $location
        $routeParams
        $timeout
        $url
        $window
        app
        appRoute
        InputConnections
        Integrations
        jobService
        jobTypes
        notification
      ) ->

        view = @

        _connectionType = 'ad-words';
        _defaultConfig = 
          id: null
          name: _connectionType
          type: _connectionType
          properties: {}
          credentials: {}
        _pollDelay = 10000;
        _pollPromise = null
        _nextStepUrl = appRoute("/magento/connect/mysql/start")

        _IntegrationsInstance = Integrations($routeParams.clientId)
        _InputConnectionsInstance = InputConnections($routeParams.clientId)

        view.connection = null;
        view.hasSelectedProfile = false;
        view.jobError = false
        view.loading = false;
        view.profileOptions = {};
        view.lockImgUrl = $url('') + '/images/lock.png';

        _handleAuthError = (response) ->
          if response?.data?.error?
            _handleError(response.data.error)
          else
            _handleError("An error occurred while authorizing this integration. Please try again.")

        _handleError = (message) ->
          notification.clear("global")
          notification.error("Something went wrong.", message, "global")
        
        _handleSuccess = (message) ->
          notification.clear("global")
          notification.success("Success.", message, "global")
        
        _handleWarning = (message) ->
          notification.clear("global")
          notification.warning("Warning.", message, "global", null, 10)

        _navigateToNextStep = () ->
          $location.path(_nextStepUrl)

        _pollJob = (wasQueued) ->
          view.loading = false
          view.jobQueued = true
          jobService(jobTypes.AUTODASH_API_CONNECTION).fetch()
          .then (response) ->
            allJobs = response.data
            if(!wasQueued && !allJobs.length)
              _queueJob()
            else if(wasQueued && !allJobs.length)
              _resetPoll(wasQueued)
            else
              latestJobStatus = allJobs[0].status.name
              if latestJobStatus is "Completed Successfully"
                _jobSuccess()
              else if latestJobStatus.indexOf("Error") isnt -1
                view.jobError = true
              else
                _resetPoll(wasQueued)

        _queueJob = () ->
          view.loading = true
          jobService(jobTypes.AUTODASH_API_CONNECTION).queue(
                  metaId: view.connection.meta_id
                  userId: app.getUserId()
                ).then((success) ->
                  view.jobQueued = true
                  _jobId = success.id
                  _pollJob(true)
                , (error) ->
                  view.jobQueued = false
                  _handleError("Error queuing Adwords connection and autodash job.");
                ).finally(()->
                  view.loading = false
                )

        _resetPoll = (wasQueued) ->
          _pollPromise = $timeout(() ->
            _pollJob(wasQueued)
          , _pollDelay)

        _jobSuccess = () ->
          _navigateToNextStep()

        view.navToNext = () ->
          _navigateToNextStep()

        view.profileLoadError = () ->
          _handleError('Profile Load Error')
          view.hasAuthorized = false;

        view.saveAndAuth = () ->
          if(!$routeParams.connectionId)
            view.connection = _defaultConfig
          view.loading = true;
          _InputConnectionsInstance.save(view.connection).then((success) ->
            view.connection = success
            _IntegrationsInstance.oauth2Authorize(view.connection).then((response) ->
              $window.location.href = response.authorize_url
            , (error) -> 
              _handleAuthError(error)
            )
          ,(error) ->
            _handleError("An error occurred while saving this integration. Please try again.")
          ).finally(() ->
            view.loading = false
          )
        
        view.saveProfile = () ->
          if(view.profileOptions.customerIds? and view.profileOptions.customerIds isnt "")
            view.connection.properties.customer_ids = view.profileOptions.customerIds
          else
            _handleWarning("Please select at least one Google Ads profile for the integration.")
            return
          view.loading = true
          _InputConnectionsInstance.save(view.connection).then((success) ->
              view.hasSelectedProfile = true
              _queueJob()
              _handleSuccess("Your integration was successfully saved.")
            ,(error) -> 
              _handleError("An error occurred while saving this integration. Please try again.")          
            ).finally(() ->
              view.loading = false
              _InputConnectionsInstance.deleteTemporarySecrets(view.connection.id)
            )

        view.$postLink = () ->
          view.loading = true 
          if($routeParams.connectionId)
            _InputConnectionsInstance.getByMetaId($routeParams.connectionId, false).then((success)->
              if($routeParams.error)
                _handleError("An error occurred while saving this integration. Please try again.")
              else
                view.hasAuthorized = true
              view.connection = success
              if(view.connection?.properties?.customer_ids and view.profileOptions.customerIds isnt "")
                view.hasSelectedProfile = true
                _pollJob(false)
              else
                view.hasSelectedProfile = false
            ,(error)->
              _handleError('An error occurred while loading this connection');
            ).finally(() ->
              view.loading = false
            )
          else
            view.hasAuthorized = false
            _InputConnectionsInstance.get().then((response) ->
              gaConnections = response.filter((connection) ->
                connection.type is 'ad-words'
              )
              if(gaConnections.length)
                $location.path(appRoute("/magento/connect/googleAdwords/#{gaConnections[0].meta_id}"))
            , (error) ->
              _handleError('Error loading connections information.')
            ).finally(() ->
              view.loading = false
            )

        view.$onDestroy = () ->
          if(_pollPromise)
            $timeout.cancel(_pollPromise)


        return view
    ]
]
